import { Link } from "react-router-dom";
import { Lock, Sparkles, ArrowRight, X } from "lucide-react";

export default function UpgradeModal({ open, onClose }) {
    if (!open) return null;
    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/70 backdrop-blur-sm"
            data-testid="upgrade-modal"
        >
            <div className="relative w-full max-w-md rounded-3xl bg-gradient-to-br from-[#0F2D44] to-[#071A2F] border border-gold/30 p-8 shadow-2xl">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 h-8 w-8 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 flex items-center justify-center"
                    aria-label="Close"
                >
                    <X className="h-4 w-4" />
                </button>

                <div className="mx-auto h-14 w-14 rounded-2xl bg-gold/15 border border-gold/40 flex items-center justify-center">
                    <Lock className="h-6 w-6 text-gold" />
                </div>

                <h3 className="mt-5 font-serif text-2xl font-bold text-white text-center">
                    No credits remaining
                </h3>
                <p className="mt-3 text-sm text-slate-300 text-center leading-relaxed">
                    You have used all available credits. Upgrade your plan to continue
                    analyzing tenders.
                </p>

                <div className="mt-7 grid grid-cols-3 gap-2">
                    {[
                        { name: "Starter", price: "₹299", c: "10" },
                        { name: "Pro", price: "₹499", c: "30", best: true },
                        { name: "Business", price: "₹999", c: "∞" },
                    ].map((p) => (
                        <div
                            key={p.name}
                            className={`rounded-xl p-3 text-center border ${
                                p.best
                                    ? "border-gold/60 bg-gold/10"
                                    : "border-white/10 bg-white/5"
                            }`}
                        >
                            <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
                                {p.name}
                            </p>
                            <p className="mt-1 font-mono font-bold text-white">{p.price}</p>
                            <p className="text-[10px] text-slate-500">{p.c} credits</p>
                        </div>
                    ))}
                </div>

                <Link to="/dashboard/billing" onClick={onClose} className="mt-6 block">
                    <button
                        className="luxury-btn-gold w-full h-12 rounded-2xl text-sm font-bold uppercase tracking-[0.14em] inline-flex items-center justify-center gap-2"
                        data-testid="upgrade-modal-cta"
                    >
                        <Sparkles className="h-4 w-4" /> Upgrade Plan
                        <ArrowRight className="h-4 w-4" />
                    </button>
                </Link>
                <button
                    onClick={onClose}
                    className="mt-3 w-full text-xs font-semibold text-slate-500 hover:text-white uppercase tracking-wider"
                >
                    Maybe later
                </button>
            </div>
        </div>
    );
}
